<script setup lang="ts">
import { computed } from 'vue'

import { useSearchStore } from '@shared/global-store/stores/search'
import NoSuggestionsFound from '@storefront-satch/components/molecules/search/NoSuggestionsFound.vue'
import SearchSuggestions from '@storefront-satch/components/molecules/search/SearchSuggestions.vue'
import clsx from 'clsx'

import type { HTMLAttributeClass } from '@fond-of/fondof-ui'

const searchStore = useSearchStore()

const suggestions = computed(() => searchStore.getSuggestions)

const props = defineProps<HTMLAttributeClass>()
</script>

<template>
  <div
    v-if="searchStore.showSuggestions"
    :class="
      clsx(
        'group/search-dropdown isolate z-10 w-full bg-white',
        'px-5 py-2.5',
        'lg:py-3.5',
        props.class
      )
    "
  >
    <template v-if="suggestions">
      <NoSuggestionsFound v-if="suggestions.length === 0" />
      <SearchSuggestions
        v-else
        :iterator="suggestions"
        :query="searchStore.query"
      />
    </template>
  </div>
</template>
